import { render, staticRenderFns } from "./Player.vue?vue&type=template&id=7c1a5f4b&"
import script from "./Player.vue?vue&type=script&lang=js&"
export * from "./Player.vue?vue&type=script&lang=js&"
import style0 from "./Player.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c1a5f4b')) {
      api.createRecord('7c1a5f4b', component.options)
    } else {
      api.reload('7c1a5f4b', component.options)
    }
    module.hot.accept("./Player.vue?vue&type=template&id=7c1a5f4b&", function () {
      api.rerender('7c1a5f4b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/components/Card/Player.vue"
export default component.exports